<template>
	<div class="map_geocoder">
		<div>
			<div class="mb-10">
				<div v-if="statusLoader" class="spin-position spin-lg-container">
					<i class="spin spin-lg" testid="load_animation"></i>
				</div>
				<button v-else type="button" @click="showMap" class="btn btn-default --ex-primary">Найти координаты</button>
			</div>

			<div class="map_geocoder__wrapperInputs" v-if="coords.length">
				<label for="" class="wrapper__form-control mr-10">
					<span>Широта</span>
					<input class="form-control d-input" v-model.number="coords[0]" type="text" data-test-id="geo_card_latitude" />
				</label>
				<label for="">
					<span>Долгота</span>
					<input
						class="form-control d-input"
						v-model.number="coords[1]"
						type="text"
						data-test-id="geo_card_longitude" />
				</label>
			</div>
		</div>

		<modal :visible.sync="showMapFlag">
      <div slot="header" class="text-right">
        <button class="btn btn-default --ex-primary" type="button" data-test-id="accept_btn" @click="acceptModal">Закрыть</button>
        <!--<button class="btn btn-danger --ex-primary" type="button" @click="cancelModal">Отмена</button>-->
      </div>
			<div slot="body">
				<form action=""  class="form-horizontal">
					<div 	v-for="f in selectFieldsFromDatabase"
              :key="f.RANDOM_KEY"
							:class="`card-str-${f.dbcolname}${f.likeStatic ? ' like-static' : ''}`">
            <div class="form-group"
                 :hidden="f.ctrlParams.isHidden">
                <label class="control-label col-md-5">
								<span :title="f.dbcolname">{{ f.name }}</span
                ><template v-if="f.required">&nbsp;<b style="color: red">*</b></template>
                    <template v-if="f.description"
                    >&nbsp;<tip :description="f.description"><span v-html="f.description"></span></tip
                    ></template>
                </label>
                <div class="col-md-19" :style="{ display: f.ctrlCode === 'datetime' ? 'flex' : 'block' }">
                <component
                        :is="f.ctrlCode"
                        :key="`component_${f.RANDOM_KEY}`"
                        :field_meta="f"
                        :value.sync="f.value"
                        :view_type="'card'"

                        :disabled="f.disabled"
                />
								</div>
						</div>
					</div>
            <div v-if="input" class="row mb-10">
                <div class="col-md-12"></div>
                <div class="col-md-12 text-right">
                    <button class="btn btn-default --ex-primary" type="button" data-test-id="find_address_btn" @click="handleClickFindAddress">Показать на карте ( найти координаты )</button>
                </div>
            </div>
					<hr>
				</form>

				<div class="map_geocoder__wrapperInputs mb-10" v-if="coords.length">
					<label for="">
						<span>Широта</span>
						<input
							class="form-control d-input"
							v-model.number="coords[0]"
							type="text"
							data-test-id="geo_modal_latitude" />
					</label>
					<label for="">
						<span>Долгота</span>
						<input
							class="form-control d-input"
							v-model.number="coords[1]"
							type="text"
							data-test-id="geo_modal_longitude" />
					</label>
				</div>

				<div>
					<yandex-map :coords="coords" :zoom="10" @click="getCoords">
						<ymap-marker v-if="markerCoords.length" :coords="markerCoords" marker-id="123" />
					</yandex-map>
				</div>
			</div>
		</modal>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
import ctrlMixins from "./_mixins.js";
import urlUtil from "./../util-url";
import axios from "axios";
import { ctrlParamsForAll, selectFieldsFromDatabase } from './_common-stuff.ts';

import text_static from './text_static.vue';
import text_input from './text_input.vue';
import dropdown from './dropdown.vue';

import modal from "./../modal.vue";

import { yandexMap, ymapMarker } from "vue-yandex-maps";

//const GEOCODE_URL = "https://geocode-maps.yandex.ru"; // https://geocode-maps.yandex.ru
const GEOCODE_URL = "/yageocode";
const YA_KEY = "a73d3062-5990-4083-ad6d-6e5279b91fd8";
// const CONST_KEY = 'ea20a893-9fa4-4d86-ad98-b8b8bf744bb6';
const DEFAULT_COORDS = [55.755864, 37.617698];

export default {
	name: "map_geocoder",
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: "Геокодер",
		params: {
			selectFieldsFromDatabase,
			...ctrlParamsForAll,
		}
	},
	components: {
    yandexMap,
    ymapMarker,
    modal,
    dropdown,
    text_input,
    text_static
  },
	props: {
		value: {
			default: "",
			required: false
		},
		card_meta: {
			required: false,
			default: null
		}
	},
	data() {
		let coords = [];

		return {
			oldCoords: [],
			oldSelectFieldsFromDatabase: [],
			markerCoords: [...coords],
			coords,
			input: "",
			showMapFlag: false,
			longitudeElem: null,
			statusLoader: false,
	  	selectFieldsFromDatabase: []
		};
	},
	watch: {
		coords() {
			// нужно перерерисовыветь маркер, тк он не обновляется
			this.markerCoords.length = 0;
			this.markerCoords = [...this.coords];

			this.c_value = this.coords[0];
			this.longitudeElem.value = String(this.coords[1]);
		}
	},
	created () {
    const availableTypes = ['dropdown', 'text_static', 'text_input']
    if (this.c_ctrlParams.selectFieldsFromDatabase &&  this.c_ctrlParams.selectFieldsFromDatabase.length) {
      this.selectFieldsFromDatabase = this.card_meta.filter((cm) => {
        const { dbcolname, ctrlCode } = cm;
        return this.c_ctrlParams.selectFieldsFromDatabase.includes(dbcolname) && availableTypes.includes(ctrlCode);
      })
    }
  },
  mounted() {
		this.getCityMounted(true);
		this.getCoordsMounted();
	},
	methods: {
		getCoordsMounted() {
			if (this.$props.value && this.longitudeElem.value) {
				this.coords = [+this.$props.value, +this.longitudeElem.value];
			}
			this.oldCoords = [...this.coords];
			this.oldSelectFieldsFromDatabase = this.selectFieldsFromDatabase.map((el) => {
				return {
					name: el.dbcolname,
					value: el.value
				}
			});
		},
		getCityMounted(statusMounted = false) {
			let city_id,
				post_address,
				params = "";

			// Нужно получить город, улицу и широту
			this.card_meta.map((el) => {
				if (el.dbcolname === "longitude" || el.dbcolname === "longitude2" || el.dbcolname === "coord_longitude") {
					this.longitudeElem = el;
				}

				if (this.c_ctrlParams.selectFieldsFromDatabase && this.c_ctrlParams.selectFieldsFromDatabase.length) {
					this.c_ctrlParams.selectFieldsFromDatabase.forEach((selectField) => {
						if (selectField === el.dbcolname) {
							let value = '';

							if (typeof el.value === "object") {
									value = `${el.value.name || ''}, `;
							} else if (el.srv_options && Array.isArray(el.srv_options) && el.srv_options.length) {
									const item = el.srv_options.find(v => v.id === el.value);
                  value = !!item ? `${item.name || ''}, ` : `${el.value || ''}, `;
							} else {
                 value = `${el.value || ''}, `;
							}
							params += value;
						}
					});
					if (!statusMounted) {
						this.statusLoader = false;
						this.showMapFlag = true;
					}
					return;
				}

				// в разных армах поля в базе называются по разному
				if (el.dbcolname === "post_address" || el.dbcolname === "address" || el.dbcolname === "address2") {
					post_address = el.value;
				}
				if (el.dbcolname === "city_id" || el.dbcolname === "settlement") {
					/*
						Если в карточке выбрать новый город, то приходит не data: { id: 1, name: 'test' }, а data: 1,
						Если там число, нужно отправить запрос на сервер, чтобы получить название
					*/
					if (typeof el.value === "string") {
						city_id = el.value;
					} else if (typeof el.value === "number") {
						const baseUrl =
							urlUtil.getDomain() +
							urlUtil.getPath() +
							this.$route.params.vpId +
							"/" +
							el.ctrlParams.useArmId +
							"/data";
						this.getNameById({ baseUrl, id: el.value }, (name) => {
							city_id = name;
							this.input = `${city_id ? city_id + ", " : ""}${post_address ? post_address : ""}`;
							this.statusLoader = false;
							this.showMapFlag = true;
						});
					} else {
						city_id = el.value.name;
						if (!statusMounted) {
							this.statusLoader = false;
							this.showMapFlag = true;
						}
					}
				} else {
					if (!statusMounted) {
						this.statusLoader = false;
						this.showMapFlag = true;
					}
				}
			});
			this.input = params ? params : `${city_id ? city_id + ", " : ""}${post_address ? post_address : ""}`;
		},
		getNameById(data, cb) {
			axios
				.get(`${data.baseUrl}?id=${data.id}`)
				.then(({ data }) => {
					data.records[0].fields.forEach((item) => {
						if (item.fieldId === "name") {
							cb(item.value);
						}
					});
				})
				.catch((e) => {
					console.log(e);
					this.statusLoader = false;
				});
		},
		acceptModal() {
			this.showMapFlag = false;
			this.oldCoords = this.coords;
		},
		cancelModal() {
			this.showMapFlag = false;
			this.coords = [...this.oldCoords];

			this.oldSelectFieldsFromDatabase.forEach((el) => {
				const { name, value } = el;
				const item = this.card_meta.find((e) => e.dbcolname === name);
				if (item) {
            item.value = value || null;
				}
			})
		},
		getCoords(e) {
			this.coords = e.get("coords");
		},
		sendQuery() {
	  	// геокодер
		  return new Promise((resolve, reject) => {
				axios
				.get(`${GEOCODE_URL}/1.x?apikey=${YA_KEY}&geocode=${this.input}&format=json`)
				.then(({ data }) => {
					const coords = data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos;
					const [longitude, latitude] = coords.split(" ");
					this.coords = [Number(latitude), Number(longitude)];
		  		resolve ();
				})
				.catch((e) => {
					console.log(e.response);
					this.statusLoader = false;
		  		reject(e)
				});
			})
		},
		showMap() {
			this.statusLoader = true;
			this.getCityMounted();
			// если есть координаты, то геокодер не запрашиваем
			if (!this.coords.length) {
				this.sendQuery().catch(() => {
				  this.coords = DEFAULT_COORDS;
				})
			}
		},
		handleClickFindAddress() {
      this.getCityMounted(false);
      this.sendQuery();
		}
	}
};
</script>

<style scoped lang="css">
.map_geocoder .spin-lg-container {
	text-align: left;
}

.map_geocoder .spin-lg:after {
	font-size: 2rem;
}

.map_geocoder .spin-lg {
	padding: 0;
}

.map_geocoder__wrapperInputs {
	display: flex;
	flex-direction: column;
}

.mr-10 {
	margin-right: 10px;
}

.mb-10 {
	margin-bottom: 10px;
}

.modal-container.wide {
	width: 80%;
}

.ymap-container {
	height: 600px;
}
</style>
